import React from "react";
import { Select, Checkbox } from "antd";
import useShopStore from "../states/useShop";

const ShopSelect = ({
  selectedItems,
  onConfirm,
  options,
  placeholder = "Search shop name",
  size = "large",
}) => {
  const { shopsCache } = useShopStore();

  // Function to render the label based on shop name
  const labelRender = (props) => {
    const { label, value } = props;
    if (label) {
      return shopsCache?.["undefined"]?.find((e) => e.id === value)?.name || label;
    }
    return <span>Select shops</span>;
  };

  // Function to handle the filtering of options
  const filterOption = (input, option) => (option?.name ?? "").toLowerCase().includes(input.toLowerCase());

  // Function to render the dropdown menu with the 'Select All' checkbox
  const dropdownRender = (menu) => (
    <div>
      {menu}
      <div style={{ padding: "8px", borderTop: "1px solid #e8e8e8" }}>
        <Checkbox
          checked={selectedItems.length === options?.length}
          onClick={(e) => onConfirm(e.target.checked ? options.map((x) => x.value) : [])}
        >
          Select All
        </Checkbox>
      </div>
    </div>
  );

  return (
    <Select
      value={selectedItems}
      mode="multiple"
      size={size}
      placeholder={placeholder}
      style={{ width: "100%" }}
      maxTagCount="responsive"
      filterOption={filterOption}
      labelRender={labelRender}
      dropdownRender={dropdownRender}
      onChange={onConfirm}
      options={options}
    />
  );
};

export default ShopSelect;
